import { GetCommentReplyListResponseType } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { COMMENT_REPLY_LIST } from '../apis';

export type SortReplyListType =
  | 'title'
  | 'status'
  | 'postType'
  | 'periodType'
  | '';
export type OrderReplyListType = 'DESC' | 'ASC' | '';

interface Props {
  limit: number;
  channelID?: string;
  keyword?: string;
  offset?: number;
  sortBy?: SortReplyListType;
  orderBy?: OrderReplyListType;
}

const defaultData = {
  totalCount: 0,
  filterCount: 0,
  commentReplies: [],
  limit: 0,
  offset: 0,
};

async function getCommentReplyList(
  limit: number,
  channelID?: string,
  keyword?: string,
  offset?: number,
  sortBy?: SortReplyListType,
  orderBy?: OrderReplyListType,
): Promise<GetCommentReplyListResponseType> {
  return axios
    .get(
      `${COMMENT_REPLY_LIST}?limit=${limit}${
        channelID ? `&projectChannelId=${channelID}` : ''
      }${keyword ? `&keyword=${keyword}` : ''}${
        offset ? `&offset=${offset}` : ''
      }${sortBy ? `&sortBy=${sortBy}` : ''}${
        orderBy ? `&orderBy=${orderBy}` : ''
      }`,
    )
    .then((res) => res.data.data)
    .catch((err) => {
      return defaultData;
    });
}

export function useGetCommentReplyList({
  limit,
  channelID,
  keyword,
  offset,
  sortBy,
  orderBy,
}: Props) {
  return useQuery({
    queryKey: [
      'get-comment-reply-list',
      { limit, projectChannelID: channelID, keyword, offset, sortBy, orderBy },
    ],
    queryFn: () => {
      if (limit) {
        return getCommentReplyList(
          limit,
          channelID,
          keyword,
          offset,
          sortBy,
          orderBy,
        );
      } else {
        return defaultData;
      }
    },
  });
}
